import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'ProjectsAPI';

export const projectsAPI = {
  getAll: async (showNotification = true) => {
    try {
      const response = await api.get('/projects');
      return handleSuccessResponse(response, MODULE_NAME, 'Получение проектов', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении проектов');
    }
  },

  get: async (projectUUID, showNotification = true) => {
    try {
      const response = await api.get(`/projects/${projectUUID}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получение проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении проекта');
    }
  },

  getToken: async (projectUUID, showNotification = false) => {
    try {
      const response = await api.get(`/projects/${projectUUID}/token`);
      return handleSuccessResponse(response, MODULE_NAME, 'Получение токена', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении токена');
    }
  },

  steamProfiles: async (steamids) => {
    try {
      const response = await api.get('/steam/profiles', { params: { ids: steamids.join(',') } });
      return handleSuccessResponse(response, MODULE_NAME, 'Получение профилей Steam', false);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении профилей Steam');
    }
  },

  valheim: async (projectUUID, method, path, data) => {
    try {
      const response = await api.request({ method, url: `/projects/${projectUUID}/valheim/${path}`, data });
      return handleSuccessResponse(response, MODULE_NAME, 'Управление сервером', false);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'управлении сервером');
    }
  },

  delete: async (projectUUID, showNotification = true) => {
    try {
      const response = await api.delete(`/projects/${projectUUID}`);
      return handleSuccessResponse(response, MODULE_NAME, 'Удаление проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'удаление проекта');
    }
  },

  patch: async (params, showNotification = true) => {
    try {
      const response = await api.patch('/projects', params);
      return handleSuccessResponse(response, MODULE_NAME, 'Изменение проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'изменение проекта');
    }
  },

  create: async (params, showNotification = true) => {
    try {
      const response = await api.post('/projects', params);
      return handleSuccessResponse(response, MODULE_NAME, 'Создание проекта', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'создание проекта');
    }
  },
};